import React, {Component} from "react";
import PropTypes from "prop-types";

export default class TrendImage extends Component {

  static propTypes = {
    "answer": PropTypes.object.isRequired,
    "loadHandler": PropTypes.func.isRequired,
    "onAnswer": PropTypes.func.isRequired,
    "surveyFields": PropTypes.object.isRequired
  };

  handleClick = () => {
    const {"answer": {surveyFields}, onAnswer} = this.props;
    onAnswer(surveyFields, this.isSelected());
  };

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.handleClick();
    }
  }

  isSelected = () => {
    const {
      "answer": {"surveyFields": answerFields},
      surveyFields
    } = this.props;

    /*
     * Assume true, look for any answerField that is different from
     * corresponding surveyField
     */
    return Object.keys(answerFields).reduce(
      (selected, key) => selected
        ? answerFields[key] === surveyFields[key]
        : false,
      true
    );
  };

  onLoad = () => {
    const {loadHandler} = this.props;
    loadHandler();
  };

  displayDemiFineSubText = (answerPrompt) => {
    if (answerPrompt === "Demi-Fine") {
      return (
        <p className="extra-small mv0">
          (18K Gold Plated + Sterling Silver)
        </p>
      );
    }

    return null;
  };

  render () {
    const {answer} = this.props;
    const imageUrlPrefix = "https://karat-herokuapp-com.freetls.fastly.net/s3media";

    return (
      <div className="TrendImage mb40">
        <img
          alt={`Press enter for ${answer.prompt}`}
          className={this.isSelected()
            ? "trend color-tangerine-border"
            : "trend color-grey-border"}
          onClick={this.handleClick}
          onKeyDown={this.handleKeyDown}
          onLoad={this.onLoad}
          src={`${imageUrlPrefix}/style_survey/${answer.image}.png`}
          tabIndex="0"
          title={answer.prompt}
        />
        <p className="lh24 mt8 mb0">
          {answer.prompt}
        </p>
        { this.displayDemiFineSubText(answer.prompt) }
      </div>
    );
  }
}
